import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginPageComponent } from './Modules/Oauth/Components/login-page/login-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatButtonModule} from '@angular/material/button';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
// import { HomePageComponent } from './Modules/Home/Components/home-page/home-page.component';
import { OauthModule } from './Modules/Oauth/oauth.module';
import { HomeModule } from './Modules/Home/home.module';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatCardModule} from '@angular/material/card';
import { FormsModule } from '@angular/forms';
// import { BordMembersComponent } from './Modules/Home/Components/bord-members/bord-members.component';
// import { GroupsComponent } from './Modules/Home/Components/groups/groups.component';
import {  ReactiveFormsModule} from '@angular/forms';
import { AuthGuard } from './auth.guard';
import { SignUpComponent } from './Modules/Oauth/Components/sign-up/sign-up.component';
// import { CreateBmDialogComponent } from './Modules/Home/Components/create-bm-dialog/create-bm-dialog.component';
//import {MatDialogModule} from "@angular/material/dialog";
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { ErrorInterceptor } from './error-interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthService } from './auth.service';
import { ErrorIntercepterService } from './error-intercepter.service';
// import {  HighchartsChartModule } from 'highcharts-angular';
// import { MatDialogModule, MatDialogRef} from "@angular/material/dialog";

import { CustomerOnboardingComponent } from './Modules/Onboard/Components/customer-onboarding/customer-onboarding.component';
import { OnboardModule } from './Modules/Onboard/onboard.module';

import { Ng2TelInputModule } from 'ng2-tel-input';





@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    SignUpComponent,
    // HighchartsChartComponent
    // HomePageComponent,
    // BordMembersComponent,
    // GroupsComponent
    CustomerOnboardingComponent,


    
  ],
  imports: [
    BrowserModule,
    HomeModule,
    OauthModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatGridListModule,
    BrowserAnimationsModule, 
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSidenavModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatSnackBarModule,
    // HighchartsChartModule
    // MatDialogModule,
    // MatDialogRef
    FormsModule,
    OnboardModule,
    Ng2TelInputModule.forRoot()
  ],
  providers: [
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AuthService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorIntercepterService, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
